/**
 * @created on 2018/7/20
 * @author zensp <.com>
 **/

// 心理日记
const calendar = resolve =>
  require(['../../../views/xinlidaily/calendar'], resolve)

export default [
  // 心理日记
  {
    path: '/calendar',
    component: calendar
  }
]



// WEBPACK FOOTER //
// ./src/router/page/xinlidaily/calendar.js